<template>
  <div
    class="loader"
    :class="[
      {
        'loader--white': white && !opacity,
        'loader--white-opacity': white && opacity
      }
    ]"
    :style="styles"
  >
    <svg
      :fill="fill"
      class="loader__icon"
      version="1.1"
      id="loader-1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="40px"
      height="40px"
      viewBox="0 0 50 50"
      style="enable-background:new 0 0 50 50;"
      xml:space="preserve"
    >
      <path
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    isAbsolute: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Boolean,
      default: false
    },
    fill: {
      type: String,
      default: "#005197"
    }
  },
  computed: {
    styles() {
      return this.isAbsolute ? "position: absolute" : "position: fixed";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.loader {
  display: block;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.05);

  &__icon {
    @include centerAbsolutely();
  }

  &--white {
    background: #ffffff;
  }

  &--white-opacity {
    background: rgba(255, 255, 255, 0.5);
  }
}
</style>
